import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useRef,
  useCallback,
} from "react";
import styles from "./styles.module.scss";
import ListView from "@/components/AntListView";
import { Toast } from "antd-mobile";
import { ableRentalCollList } from "@/api/guland";
import { hideLoading, showLoading } from "@/components/loading";
import { getConsumableHoldCount } from "@/view/landGame/utils";

import _ from "lodash";
const SelectList = forwardRef(
  ({
    type = 1,
    filterData = {},
    seriesId,
    collectionIds,
    isConsumable = false,
    showQuantity = false,
    singleSelect = false,
    onChange,
  }, ref) => {
    const [currentSelect, setCurrentSelect] = useState([]);
    const [list, setList] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [listKey, setListKey] = useState(0);
    const currentPage = useRef(1);
    const pageSize = useRef(20);
    const fetchIdRef = useRef(0);
    const loadingMoreRef = useRef(false);
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    const getList = useCallback(async (isRefresh, loading = true) => {
      if (!isRefresh && loadingMoreRef.current) return;
      const requestId = isRefresh ? ++fetchIdRef.current : fetchIdRef.current;
      const page = isRefresh ? 1 : currentPage.current + 1;
      try {
        if (isRefresh) {
          loading && showLoading();
          currentPage.current = 1;
          loadingMoreRef.current = false;
        } else {
          loadingMoreRef.current = true;
          currentPage.current = page;
        }
        // 土地耗材 / 土地 / 其他 / 无聊猿 参数区分
        const params = {
          currentPage: page,
          pageSize: pageSize.current,
        };
        if (isConsumable) {
          params.collectionType = 3;
          params.seriesId = seriesId;
          params.collectionIds = collectionIds ?? '';
          params.rentalPeriod = -1;
        } else {
          params.collectionType = type;
          if (type === 2) {
            params.blockLevel = Number(filterData?.value) || undefined;
          } else if (type === 1) {
            params.monkeyType = Number(filterData?.value) || undefined;
          } else if (type === 3) {
            params.seriesId = seriesId;
            params.collectionIds = collectionIds;
          }
        }
        const res = await ableRentalCollList(params);
        // 忽略过期请求，避免刷新后被旧分页结果覆盖
        if (requestId !== fetchIdRef.current) return;
        loading && hideLoading();
        if (res.code !== "000000") throw res.msg;
        const nextList = res?.data?.list || [];
        if (page === 1) {
          setList(nextList);
          setListKey((key) => key + 1);
        } else {
          setList((prev) => [...prev, ...nextList]);
        }
        if (isRefresh) setIsLoad(true);
        setHasMore(nextList.length >= pageSize.current);
      } catch (error) {
        if (requestId !== fetchIdRef.current) return;
        loading && hideLoading();
        console.log(error);
        Toast.show(error);
      } finally {
        if (!isRefresh) {
          loadingMoreRef.current = false;
        }
      }
    }, [type, isConsumable, filterData?.value, seriesId, collectionIds]);

    useEffect(() => {
      getList(true);
    }, [getList]);

    const onSelect = (item) => {
      let arr = _.cloneDeep(currentSelect);
      let newArr = _.cloneDeep(currentSelect);
      const index = _.findIndex(arr, function (o) {
        return o?.nftNo == item?.nftNo;
      });

      if (singleSelect) {
        if (index !== -1) {
          newArr = [];
        } else {
          newArr = [item];
        }
      } else if (index !== -1) {
        newArr = _.remove(arr, function (n) {
          return n?.nftNo !== item?.nftNo;
        });
      } else {
        newArr.push(item);
      }
      if(!singleSelect && newArr?.length >50){
        Toast.show('最多选择50个')
        return
      }
      setCurrentSelect(newArr);
      onChangeRef.current && onChangeRef.current(newArr);
    };

    useImperativeHandle(ref, () => ({
      refresh:()=>{
        currentPage.current = 1
        setCurrentSelect([])
        onChangeRef.current && onChangeRef.current([]);
        setHasMore(false)
        setIsLoad(false)
        getList(true)
      }
    }), [getList]);

    return (
      <div className={styles.list_out}>
        {
          <ListView
            key={listKey}
            dataSource={list}
            hasMore={hasMore}
            style={{ paddingTop: 20 }}
            renderItem={(item, index) => {
              let isActive = false;
              try {
                currentSelect.forEach((_item) => {
                  if (_item?.nftNo === item?.nftNo) {
                    isActive = true;
                    throw "";
                  }
                });
              } catch (error) {}
              return (
                <div
                  key={`${item?.nftNo}-${item?.count ?? item?.num ?? 0}-${index}`}
                  className={`${styles.list_item} ${
                    isActive ? styles.actived : ""
                  }`}
                  onClick={() => {
                    onSelect(item);
                  }}
                >
                  <div className={styles.item_img}>
                    <img src={item?.nftImage} alt="" />
                    {showQuantity ? (
                      <div className={styles.item_quantity}>
                        拥有{getConsumableHoldCount(item)}张
                      </div>
                    ) : null}
                  </div>
                  <div className={styles.item_nftNo}>
                    {showQuantity ? item?.collectionName : item?.nftNo}
                  </div>
                </div>
              );
            }}
            onEndReached={async () => {
              await getList(false, false);
            }}
            isLoad={isLoad}
            customStyle={{ imgStyle: { width: 150, height: 150 } }}
          />
        }
      </div>
    );
  }
);

export default SelectList;
